import { h, render } from "vue";
import StoryCommentsOverlay from "%/dynamic-component-editor/components/story-comments/StoryCommentsOverlay.vue";
import { useStoryCommentsStore } from "%/dynamic-component-editor/stores/story-comments-store";

let unmountOpenOverlay = null;

export function openStoryCommentsOverlay(storyId, appContext) {
  useStoryCommentsStore().openOverlay(storyId);
  if (unmountOpenOverlay) {
    return;
  }
  const host = document.createElement("div");
  host.dataset.storyCommentsOverlayHost = "";
  document.body.appendChild(host);
  unmountOpenOverlay = () => {
    render(null, host);
    host.remove();
    unmountOpenOverlay = null;
  };
  const overlay = h(StoryCommentsOverlay, { onClosed: () => unmountOpenOverlay?.() });
  overlay.appContext = appContext;
  render(overlay, host);
}
